import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";

const routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/Login.vue"),
    meta: {
      title: `เข้าสู่ระบบ`,
    },
  },
  {
    path: "/calendar",
    name: "Calendar",
    component: () => import("@/views/Calendar.vue"),
    meta: {
      title: `Calendar`,
    },
  },
  {
    path: "/",
    name: "Apps",
    component: () => import("@/layouts/DefaultLayout.vue"), // Fixed here
    meta: {
      requiresAuth: true,
      roles: ["admin", "manager", "user"],
    },
    children: [
      {
        path: "/test",
        name: "Test",
        component: () => import("@/views/Test.vue"),
        meta: {
          title: `Test`,
        },
      },
      {
        path: "/profile",
        name: "Profile",
        component: () => import("@/views/Profile.vue"),
        meta: {
          title: `Profile`,
        },
      },
      {
        path: "/",
        name: "Dashboard",
        component: () => import("@/views/Dashboard.vue"),
        meta: {
          title: `หน้าหลัก`,
        },
      },
      {
        path: "/items",
        name: "Items",
        component: () => import("@/views/Items.vue"),
        meta: {
          title: `รายการจองห้องประชุม`,
          roles: ["admin", "manager"],
        },
      },
      {
        path: "/wait",
        name: "Wait",
        component: () => import("@/views/Wait.vue"),
        meta: {
          title: `รายการจองห้องประชุม (รออนุมัติ)`,
        },
      },
      {
        path: "/booking",
        name: "Booking",
        component: () => import("@/views/Booking.vue"),
        meta: {
          title: `จองห้องประชุม`,
        },
      },
      {
        path: "/meeting-room",
        name: "MeetingRoom",
        component: () => import("@/views/MeetingRoom.vue"),
        meta: {
          title: `ห้องประชุม`,
          roles: ["admin", "manager"],
        },
      },
      {
        path: "/department",
        name: "Department",
        component: () => import("@/views/Department.vue"),
        meta: {
          title: `หน่วยงาน`,
          roles: ["admin", "manager"],
        },
      },
      {
        path: "/group-department",
        name: "GroupDepartment",
        component: () => import("@/views/GroupDepartment.vue"),
        meta: {
          title: `หน่วยงาน`,
          roles: ["admin", "manager"],
        },
      },
      {
        path: "/equipment",
        name: "Equipment",
        component: () => import("@/views/Equipment.vue"),
        meta: {
          title: `อุปกรณ์โสตทัศนูปกรณ์`,
          roles: ["admin", "manager"],
        },
      },
      {
        path: "/room-layout",
        name: "RoomLayout",
        component: () => import("@/views/RoomLayout.vue"),
        meta: {
          title: `รูปแบบการจัดห้อง`,
          roles: ["admin", "manager"],
        },
      },
      {
        path: "/meeting-type",
        name: "MeetingType",
        component: () => import("@/views/MeetingType.vue"),
        meta: {
          title: `ประเภทการประชุม`,
          roles: ["admin", "manager"],
        },
      },
      {
        path: "/meeting-room-report",
        name: "MeetingRoomReport",
        component: () => import("@/views/MeetingRoomReport.vue"),
        meta: {
          title: `รายงานการใช้ห้องประชุม`,
          roles: ["admin", "manager"],
        },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// router.beforeEach((to, from, next) => {
//   document.title = `${to.meta.title} | ${store.state.projectName}`;

//   // Check if the route requires authentication
//   const isAuthenticated = !!localStorage.getItem("token");

//   if (to.meta.requiresAuth && !isAuthenticated) {
//     // Redirect to login if authentication is required and user is not authenticated
//     next("/login"); // Ensure it redirects to the login page
//     return; // Stop further navigation
//   }

//   // Check if the user has the required roles
//   const userRoles = store.state.role; // Ensure roles are being correctly fetched
//   const requiredRoles = to.meta.roles;

//   // if (requiredRoles && !requiredRoles.some(role => userRoles.includes(role))) {
//   //   // If the user doesn't have the required roles, redirect to login or home
//   //   next('/login');  // Redirect to login if no roles match
//   // } else {
//   //   next(); // Proceed with the navigation
//   // }

//   if (requiredRoles) {
//     if (
//       !userRoles ||
//       !Array.isArray(userRoles) ||
//       !requiredRoles.some((role) => userRoles.includes(role))
//     ) {
//       next("/login");
//       return;
//     }
//   }
//   next();
// });

// router.beforeEach((to, from, next) => {
//   document.title = `${to.meta.title} | ${store.state.projectName || "ระบบ"}`;

//   const isAuthenticated = !!localStorage.getItem("token");

//   if (to.meta.requiresAuth && !isAuthenticated) {
//     next("/login");
//     return;
//   }

//   const userRoles = store.state.role;
//   const requiredRoles = to.meta.roles;
  
//   if (requiredRoles) {
//     if (!userRoles || !Array.isArray(userRoles) || !requiredRoles.some(role => userRoles.includes(role))) {
//       next('/login');
//       return;
//     }
//   }

//   next();
// });

router.beforeEach(async (to, from, next) => {
  document.title = `${to.meta.title} | ${store.state.projectName || 'ระบบ'}`;

  const token = localStorage.getItem('token');
  const isAuthenticated = !!token;

  if (to.meta.requiresAuth && !isAuthenticated) {
    next('/login');
    return;
  }

  const requiredRoles = to.meta.roles;
  const userRoles = store.state.role;

  // ป้องกัน null
  if (requiredRoles) {
    if (!userRoles || !Array.isArray(userRoles)) {
      console.warn('Missing roles in store, redirecting to login.');
      next('/login');
      return;
    }

    if (!requiredRoles.some(role => userRoles.includes(role))) {
      console.warn('User role unauthorized, redirecting to login.');
      next('/login');
      return;
    }
  }

  next();
});


export default router;
